import { type ProjectCode } from '@constants'
import { type Campaign } from '@hooks-api/types/dataModel/campaigns'

/**
 * 從 campaign 的 icons 解析出當前品牌的客製化 icon url，取不到時回傳 undefined
 *
 * 後端目前暫時無法提供 icons 的 project_code（待處理），故無法精確配對。
 * 暫時作法：單品牌時允許不配對 project_code，直接取用第一個 icon_url（icons 只會有一顆，無歧義）；
 * 多品牌若拿不到 project_code 則回 undefined，讓呼叫端 fallback 回 brand_image，避免套錯品牌。
 * 多品牌配對將於 SD-22080 隨後台客製化 logo 一併修正，屆時移除 singleBrandIcon 這條暫解。
 */
export const resolveBrandIcon = (campaign: Campaign | undefined, projectCode: ProjectCode | null): string | undefined => {
  const matchedIcon = campaign?.icons?.find(icon => icon.project_code === projectCode)?.icon_url
  // TODO(SD-22080): 後端補上 icons[].project_code 後移除 singleBrandIcon 暫解
  const singleBrandIcon = campaign?.brand_codes_info.length === 1 ? campaign?.icons?.[0]?.icon_url : undefined
  return matchedIcon ?? singleBrandIcon
}
